<template>
  <el-dialog :title="title" :visible.sync="visible" width="80%" @close="closeHandle">
    <el-form class="platform-info-edit-wrp" :model="formData" :rules="rules" ref="formData" v-if="platform" label-width="120px">
      <div class="conf">
        <el-form-item label="模版名称" prop="templateName">
          <el-input placeholder="请输入类目属性模版名称，最多不超过20个字" :maxlength="20" v-model="formData.templateName" clearable>
          </el-input>
        </el-form-item>
        <!-- <el-form-item v-if="platform === 'tm'" label="店铺:" prop="shop">
          {{ shop.shortTitle || shop.title }}
          <el-button type="link" @click="switchShop">切换店铺</el-button>
        </el-form-item> -->
        <el-form-item label="商品分类:" required>
          <div class="category ft-12">
            <category-input ref="categoryInputRef" v-model="categoryIds" :platform="platform" :hideCache="true" />
          </div>
        </el-form-item>
      </div>
      <div class="conf">
        <el-form-item label="类目属性:" v-if="categoryIds.length">
          <component
            :is="`${platform}CategoryProps`"
            ref="categoryAttrsForm"
            :categoryIds="categoryIds"
            :shopId="shopId"
            v-model="platformCatProp"
            :initAttrData="initAttrData"
            :initMeasureData="initMeasureData"
            :categoryPropertyPics="fxgCategoryPropertyPics"
            source="platformConf"
            @changePropertyPics="changeFxgPropertyPics"
          >
          </component>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeHandle">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
    <el-dialog-select-shop
        :visible.sync="shopDialogVisible"
        :shopData="shopDialogList"
        :selected="shop.userId"
        :multiple="false"
        placeholder="店铺名称"
        @confirm="confirmSelectShop"
    ></el-dialog-select-shop>
  </el-dialog>
</template>

<script>
import CategoryInput from '@components/prod/center/components/PlatformCategoryInput/index.vue';

import kuaishouCategoryProps from '@components/prod/center/components/KuaishouInfoForm/CategoryProps.vue';
import fxgCategoryProps from '@components/prod/center/components/DdianInfoForm/CategoryAttr.vue';
import jdCategoryProps from '@components/prod/center/components/JdongInfoForm/CategoryProps.vue';
import tbCategoryProps from '@components/prod/center/components/TBInfoForm/BatchCatIndex.vue';
import tmCategoryProps from '@components/prod/center/components/TMInfoForm/CategoryProps.vue';
import pddCategoryProps from '@components/prod/center/components/PddInfoForm/components/CategoryAttr.vue';
import wxxdCategoryProps from '@components/prod/center/components/WxxdInfoForm/CategoryProps.vue';
import alibabaCategoryProps from '@components/prod/center/components/AlibabaInfoForm/BatchCatIndex.vue';
import tjbCategoryProps from '@components/prod/center/components/TJBInfoForm/BatchCatIndex.vue';
import yzCategoryProps from '@components/prod/center/components/YouZanInfoForm/CategoryProps.vue';
import wxsphCategoryProps from '@components/prod/center/components/WxhInfoForm/CategoryProps.vue';
import xhsCategoryProps from '@components/prod/center/components/XhsInfoForm/CategoryProps.vue';

import { parseProductFormat } from '@components/prod/center/components/DdianInfoForm/service';
import { saveOrUpdatePlatformCatprop } from '@api/prod/conf/index.js';

export default {
  components: {
    CategoryInput,
    kuaishouCategoryProps,
    fxgCategoryProps,
    jdCategoryProps,
    tbCategoryProps,
    tmCategoryProps,
    pddCategoryProps,
    wxxdCategoryProps,
    alibabaCategoryProps,
    tjbCategoryProps,
    yzCategoryProps,
    wxsphCategoryProps,
    xhsCategoryProps,
  },
  data() {
    return {
      title: '新建模版',
      formData: {
        templateName: '',
      },
      shopDialogList: [],
      shopDialogVisible: false,
      shopId: '',
      shop: {},
      categoryIds: [],
      categoryId: '',
      platform: '',
      opts: {},
      row: {},
      platformCatProp: [],
      initAttrData: {},
      initMeasureData: {},
      activeName: 'base',
      visible: false,
      rules: {
        templateName: [
          { required: true, message: '必填' },
          { max: 20, message: '最多不超过20个字', trigger: 'change' },
        ],
      },
      fxgCategoryPropertyPics:{}, // 抖音属性图
    };
  },
  watch: {
    categoryIds: {
      handler(v) {
        if (v?.length) {
          this.categoryId = v[v.length - 1];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    closeHandle() {
      this.visible = false;
      this.resetInfo();
    },
    method_open(opts = {}) {
      const { platform, row } = opts;
      const { platformCatProp, id, categoryIds } = row || {};
      this.title = id ? '编辑模版' : '新建模版';
      this.opts = opts;
      if(platform === 'tm') {
        this.shopId = opts.shopId || this.$store.getters.shops_getCategoryPropShopId('tm')
        // this.shop = this.$store.getters.shops_getById(this.shopId)
        // const shopList = this.$store.getters.get_AllShops_BySource('tm');
        // this.shopDialogList = shopList.filter(shop => [2, 3].includes(shop.state) && shop.isDeadline !== 1)
      }
      if(platform === 'fxg'){
        try{
          this.fxgCategoryPropertyPics = JSON.parse(row.extendId1 || '{}')
        }catch(e){
          this.fxgCategoryPropertyPics = {}
        }
      }
      
      this.row = row;
      this.platform = platform;
      this.formData.templateName = row.templateName || '';
      this.setPlatformCatProp(platformCatProp);
      this.categoryIds = categoryIds ? categoryIds.split(',') : [];
      this.categoryIds = this.categoryIds.length ? this.categoryIds : opts.categoryIds || [];
      this.visible = true;
    },
    switchShop() {
      this.shopDialogVisible = true
    },
    confirmSelectShop(shop) {
      this.shop = shop;
      this.shopId = this.shop.id
    },
    setPlatformCatProp(platformCatProp) {
      const platform = this.platform;
      const parsePlatformCatProp = platformCatProp ? JSON.parse(platformCatProp) : [];
      if (platform === 'fxg') {
        this.platformCatProp = platformCatProp;
        const { initAttrData, initMeasureData } = parseProductFormat(platformCatProp);
        this.initAttrData = initAttrData;
        this.initMeasureData = initMeasureData;
      } else if (platform === 'pdd') {
        this.platformCatProp = parsePlatformCatProp;
        this.initAttrData = parsePlatformCatProp;
      } else {
        this.platformCatProp = parsePlatformCatProp;
      }
    },
    // 将组件相关数据初始化
    resetInfo() {
      // this.categoryIds = [];
      this.platformCatProp = [];
      this.platform = '';
      this.formData.templateName = '';
    },
    handleSave() {
      this.$refs.formData.validate(async valid => {
        if (!valid) {
          this.$message.error('请完善表单');
          return;
        }
        const platformCatProp = await this.getPlatformCatProp();
        if (!platformCatProp) return;
        const platformType = this.platform === 'alibaba' ? '1688' : this.platform;
        let extendId1 = null;
        if(this.platform === 'fxg'){
          try{
            extendId1 = JSON.stringify(this.fxgCategoryPropertyPics)
          }catch(e){
            extendId1 = '{}'
          }
        }
        const result = await saveOrUpdatePlatformCatprop({
          id: this.row.id || '',
          templateName: this.formData.templateName,
          platformType,
          categoryId: this.categoryId,
          platformCatProp,
          extendId1:extendId1 || undefined
        });
        if (result) {
          this.$message.success('保存成功！');
          this.visible = false;
          this.opts.saveFn && this.opts.saveFn();
        }
      });
    },
    getPlatformCatProp() {
      let $formCatRef = this.$refs.categoryAttrsForm;
      let $formRef = this.$refs.categoryAttrsForm;
      const platform = this.platform;
      return new Promise(resovle => {
        const validHandle = valid => {
          if (!valid) {
            this.$message.error('请完善表单');
            resovle(false);
          } else {
            let catProps = this.platformCatProp;
            if (['alibaba', 'tb'].includes(platform)) {
              catProps = $formCatRef.methods_getCatProps();
              if(!catProps[0]?.children?.length) {
                this.$message.error('当前商品分类没有类目属性，无需配置模版！');
                resovle(false);
              }
            } else if (platform === 'fxg') {
              catProps = JSON.parse(this.platformCatProp);
            }
            resovle(JSON.stringify(catProps));
          }
        };
        if (['pdd', 'tb', 'kuaishou', 'fxg', 'alibaba', 'xhs', 'tm','wxsph'].includes(platform)) {
          $formRef.validate().then(valid => {
            validHandle(valid);
          }).catch(e => {
            console.error(e)
          });
        } else if (['jd'].includes(platform)) {
          $formRef.$refs.form.validate(valid => {
            validHandle(valid);
          });
        } else {
          resovle(false);
        }
      });
    },
    // 抖音属性图修改
    changeFxgPropertyPics(val){
        let newVal = {}
        for(let key in val){
            newVal[key] = {urls:val[key]}
        }
        this.fxgCategoryPropertyPics = newVal
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-info-edit-wrp {
  ::v-deep .el-form-item__content {
    font-size: 12px;
  }
}
</style>